const BASE_URL = (process.env.REACT_APP_API_URL || "https://takci.inawo.pro").replace(/\/$/, "");

// Uniquement des adresses : aucune clé ne doit revenir ici. Ce fichier est
// importé par six écrans et part donc en clair dans le bundle, servi aux
// administrateurs comme aux organisateurs.
//
// Ont été retirés parce qu'ils n'étaient lus nulle part :
//   apiKey / googleAppKey — clé Google AIzaSyA9w… portée en double
//   projectId             — identifiant d'un projet abandonné
//   offlineUrl            — tunnel ngrok expiré depuis longtemps
export const Key = {
  baseUrl: BASE_URL,
  onlineUrl: `${BASE_URL}/`,
  photoURL: `${BASE_URL}/client/`,
  logoURL: `${BASE_URL}/event_logo/`,
  baniereURL: `${BASE_URL}/event_banniere/`,
  badgeURL: `${BASE_URL}/event_badge/`,
  IdentiteOrgaURL: `${BASE_URL}/orga_identite/`,
  driverPhotoURL: `${BASE_URL}/photo/`,
  enginPhotoURL: `${BASE_URL}/type_engin/`,
};

export default Key;
